import { useState } from "react";
import { updateNotes } from "@/mocks/homeData";

export default function EditorNotes() {
  const [toast, setToast] = useState<string | null>(null);

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(null), 2200);
  };

  return (
    <section id="note" className="scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Editorial / 编辑手记</p>
            <h2 className="mt-2 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-950 md:text-3xl">
              同一篇，持续补料
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              这页不走「刷完即忘」的路子：每出现一条能对上的新料，就并回该人物的原档案。
              你只需把本页收藏当目录，隔几天回来，翻一翻对应编号的更新时间即可。
            </p>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => showToast("提醒已登记 · 静态展示，未接入真实订阅")}
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-notification-3-line text-base leading-none" />
                关注这批人物的更新
              </button>
              <button
                type="button"
                onClick={() => showToast("补料入口示意 · 静态展示，未接入真实提交")}
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
              >
                <i className="ri-send-plane-line text-base leading-none" />
                有对得上的料，点这补
              </button>
            </div>
            <p className="mt-4 text-xs leading-6 text-foreground-500">
              页面为静态陈列展示，按钮与补料均为示意，不会真的发送或提交任何内容。
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-foreground-950">更新日志</h3>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                  <i className="ri-history-line text-sm leading-none" />
                  持续更新中
                </span>
              </div>
              <div className="mt-5 divide-y divide-background-200">
                {updateNotes.map((n, i) => (
                  <div key={i} className="flex items-start gap-4 py-4 first:pt-1 last:pb-1">
                    <span
                      className={`mt-0.5 inline-flex h-6 shrink-0 items-center rounded-full px-2.5 text-xs font-medium ${
                        n.hot ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {n.tag}
                    </span>
                    <p className="flex-1 text-sm leading-6 text-foreground-800">{n.text}</p>
                    <span className="whitespace-nowrap font-mono text-xs text-foreground-500">{n.date}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 px-4">
          <div className="flex items-center gap-2 rounded-full bg-foreground-950 px-5 py-3 text-sm text-background-50 shadow-none">
            <i className="ri-information-line text-base leading-none" />
            {toast}
          </div>
        </div>
      )}
    </section>
  );
}